<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form class="bg-white shadow-lg rounded-lg" @submit.prevent="handleSubmit(create)">
        <div class="p-10">
          <div class="pb-2 mb-4 border-b border-gray-200">
            <h2 class="text-gray-800 text-2xl font-medium">Create Product</h2>
          </div>
          <div class="md:flex gap-6">
            <div class="md:flex-col w-full md:w-4/6">
              <div class="md:flex gap-4">
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Season Creation" rules="" v-slot="{ errors }">
                    <label for="season_creation" class="label-control">Season Creation <span class="text-red-600">*</span></label>
                    <input id="season_creation" ref="season_creation" type="text" v-model="seasonCreation" maxlength="255" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div v-if="error.season_creation" class="text-sm text-red-600"><span>{{ error.season_creation[0] }}</span></div>
                </div>
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Collection" rules="required" v-slot="{ errors }">
                    <label for="collection" class="label-control">Collection <span class="text-red-600">*</span></label>
                    <MultiSelect id="collection" v-model="collection" :options="collections" :value="collection" :searchable="true" track-by="id" label="name" placeholder="Type to Search">
                      <template slot="caret">
                        <div>
                          <div class="multiselect__select">
                            <span>
                              <svg class="text-gray-500 mt-2 ml-2 w-5 h-5 fill-current" viewBox="0 0 24 24">
                                <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z"/>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </template>
                    </MultiSelect>
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.collection" class="text-sm text-red-600"><span>{{ error.collection[0] }}</span></div>
                </div>
              </div>            
              <div class="md:flex gap-4">
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Barcode" rules="required|numeric" v-slot="{ errors }">
                    <label for="barcode" class="label-control">Barcode <span class="text-red-600">*</span></label>
                    <input id="barcode" ref="barcode" type="text" v-model="barcode" maxlength="255" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div v-if="error.barcode" class="text-sm text-red-600"><span>{{ error.barcode[0] }}</span></div>                  
                </div>
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Reference" rules="required" v-slot="{ errors }">
                    <label for="reference" class="label-control">Reference <span class="text-red-600">*</span></label>
                    <input id="reference" type="text" v-model="reference" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.reference" class="text-sm text-red-600"><span>{{ error.reference[0] }}</span></div>
                </div>
              </div>
              <div class="md:flex gap-4">
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Color" rules="required" v-slot="{ errors }">
                    <label for="color" class="label-control">Color <span class="text-red-600">*</span></label>
                    <input id="color" type="text" v-model="color" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.color" class="text-sm text-red-600"><span>{{ error.color[0] }}</span></div>
                </div>
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Size" rules="" v-slot="{ errors }">
                    <label for="size" class="label-control">Size</label>
                    <input id="size" type="text" v-model="size" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.size" class="text-sm text-red-600"><span>{{ error.size[0] }}</span></div>
                </div>            
              </div>
              <div class="md:flex gap-4">          
                <div class="w-full mb-2">
                  <ValidationProvider name="Description" rules="required" v-slot="{ errors }">
                    <label for="description" class="label-control">Description <span class="text-red-600">*</span></label>
                    <input id="description" type="text" v-model="description" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div v-if="error.description" class="text-sm text-red-600"><span>{{ error.description[0] }}</span></div>
                </div>
              </div>
              <div class="md:flex gap-4">
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Weight" rules="" v-slot="{ errors }">
                    <label for="weight" class="label-control">Weight</label>
                    <input id="weight" type="text" v-model="weight" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.weight" class="text-sm text-red-600"><span>{{ error.weight[0] }}</span></div>
                </div>
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="High" rules="" v-slot="{ errors }">
                    <label for="high" class="label-control">Height</label>
                    <input id="high" type="text" v-model="high" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.high" class="text-sm text-red-600"><span>{{ error.high[0] }}</span></div>
                </div>            
              </div>
              <div class="md:flex gap-4">
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Width" rules="" v-slot="{ errors }">
                    <label for="width" class="label-control">Width</label>
                    <input id="width" type="text" v-model="width" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.width" class="text-sm text-red-600"><span>{{ error.width[0] }}</span></div>
                </div>
                <div class="md:w-1/2 mb-2">
                  <ValidationProvider name="Long" rules="" v-slot="{ errors }">
                    <label for="long" class="label-control">Length</label>
                    <input id="long" type="text" v-model="long" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.long" class="text-sm text-red-600"><span>{{ error.long[0] }}</span></div>
                </div>            
              </div>
              <div class="md:flex gap-4">
                <div class="w-full mb-2">
                  <ValidationProvider name="Carats" rules="" v-slot="{ errors }">
                    <label for="carats" class="label-control">Carats</label>
                    <input id="carats" type="text" v-model="carats" class="form-control">
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.carats" class="text-sm text-red-600"><span>{{ error.carats[0] }}</span></div>
                </div>           
              </div>                                          
              <div class="md:flex gap-4">
                <div class="w-full mb-2">
                  <ValidationProvider name="Annotation" rules="" v-slot="{ errors }">
                    <label for="annotation" class="label-control">Annotation</label>
                    <textarea id="annotation" v-model="annotation" class="form-control" rows="3"></textarea>
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.annotation" class="text-sm text-red-600"><span>{{ error.annotation[0] }}</span></div>              
                </div>
              </div>
              <div class="md:flex gap-4">
                <div class="w-full md:w-1/2 mb-2">
                  <ValidationProvider name="Unit" rules="required" v-slot="{ errors }">
                    <label for="unit" class="label-control">Unit <span class="text-red-600">*</span></label>
                    <MultiSelect id="unit" ref="unit" v-model="unit" :options="units" :value="unit" :searchable="true" placeholder="Type to Search">
                      <template slot="caret">
                        <div>
                          <div class="multiselect__select">
                            <span>
                              <svg class="text-gray-500 mt-2 ml-2 w-5 h-5 fill-current" viewBox="0 0 24 24">
                                <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z"/>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </template>
                    </MultiSelect>
                    <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                  </ValidationProvider>
                  <div v-if="error.unit" class="text-sm text-red-600"><span>{{ error.unit[0] }}</span></div>
                </div>
                <div class="flex md:w-1/2 gap-2 md:gap-4 mb-2">
                  <div class="w-full md:w-1/2">
                    <ValidationProvider name="Currency" rules="required" v-slot="{ errors }">
                      <label for="currency" class="label-control">Currency <span class="text-red-600">*</span></label>
                      <MultiSelect id="currency" ref="currency" v-model="currency" :options="currencies" :value="currency" :searchable="false" :showLabels="false">
                        <template slot="caret">
                          <div>
                            <div class="multiselect__select">
                              <span>
                                <svg class="text-gray-500 mt-2 ml-2 w-5 h-5 fill-current" viewBox="0 0 24 24">
                                  <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </template>
                      </MultiSelect>
                      <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>           
                    </ValidationProvider>
                    <div v-if="error.currency" class="text-sm text-red-600"><span>{{ error.currency[0] }}</span></div>              
                  </div>
                  <div class="w-full md:w-1/2">
                    <ValidationProvider name="Rate" rules="required" v-slot="{ errors }">
                      <label for="change_rate" class="label-control">Rate (EUR to IDR) <span class="text-red-600">*</span></label>
                      <input id="change_rate" type="text" v-model="change_rate" class="form-control text-right" @input="handleInputRate($event)">
                      <span class="text-sm text-red-600 w-full">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <div v-if="error.change_rate" class="text-sm text-red-600"><span>{{ error.change_rate[0] }}</span></div>
                  </div>
                </div>
              </div>          
            </div>
            <div class="md:flex-col w-full md:w-2/6">
              <div class="w-full mb-2">
                <label for="image" class="label-control">Image</label>
                <div v-if="!image">
                  <div class="md:h-64 border-2 border-dashed border-gray-400 flex items-center justify-center p-2 rounded-lg mb-2">
                    <img class="m-auto" :src="fileBox" />
                  </div>
                  <input type="file" id="image" ref="image" @change="onFileChange">
                </div>
                <div v-else>
                  <div class="h-auto border-2 border-dashed border-gray-400 flex items-center justify-center p-2 rounded-lg mb-2">
                    <img class="m-auto" :src="image" />
                  </div>
                  <div v-if="error.image" class="text-sm text-red-600 mb-2"><span>{{ error.image[0] }}</span></div>
                  <button class="btn btn--danger" @click="removeImage">Remove Image</button>
                </div>
              </div>
            </div>           
          </div>        
          <div class="md:flex gap-4 mt-4 mb-2">
            <button :disabled="isLoading" type="submit" class="btn btn--primary" alt="Save" title="Save">
              <span v-if="isLoading" class="block mx-5">
                <Loading />
              </span>
              <SaveIcon v-else>
                <span class="ml-2 md:block hidden">Save &amp; Continue</span>
              </SaveIcon>
            </button>
            <button :disabled="isLoading" type="button" @click="goBack()" class="btn btn--secondary" alt="Back" title="Back">
              <BackIcon>
                <span class="ml-2 md:block hidden">Back</span>
              </BackIcon>              
            </button>
          </div>                                                  
        </div>
      </form>      
    </ValidationObserver>
    <div class="fixed bg-gray-800 bg-opacity-25 w-full inset-0 top-16 md:top-0 z-50" :class="{ 'hidden': !showFunction }">
      <div class="w-52 ml-auto h-full bg-white shadow-lg right-0">
        <div class="flex p-5 border-b border-gray-200 items-center">
          <span class="flex-1 text-sm font-medium">Functions</span>
          <button type="button" class="flex right-0" @click="toggleFunction">
            <svg class="h-5 w-5 fill-current hover:text-gray-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
            </svg>
          </button>
        </div>
        <div class="p-5 items-center">
          <CollectionModal class="mb-4" />
          <UnitModal class="mb-4" />
          <RateModal class="mb-4" /> 
        </div>
      </div>            
    </div>
    <div class="fixed w-20 top-0 bottom-0 right-0 z-20">
      <div class="absolute w-16 right-0 top-1/2 bg-green-500 text-white rounded-l-full shadow-lg" :class="{ 'hidden': showFunction }">
        <button class="block ml-2 p-3 cursor-pointer" v-tooltip="'Show Function'" @click="toggleFunction">
          <svg class="h-5 w-5 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.6558 18.9896L13.5758 9.90957C14.5058 7.56957 14.0258 4.80957 12.1358 2.90957C9.83584 0.609575 6.25584 0.399574 3.70584 2.25957L7.54584 6.10957L6.12584 7.51957L2.29584 3.68957C0.435837 6.22957 0.645837 9.81957 2.94584 12.1096C4.80584 13.9696 7.51584 14.4596 9.83584 13.5896L18.9458 22.6996C19.3358 23.0896 19.9658 23.0896 20.3558 22.6996L22.6558 20.3996C23.0558 20.0196 23.0558 19.3896 22.6558 18.9896ZM19.6558 20.5896L10.1958 11.1296C9.58584 11.5796 8.90584 11.8496 8.19584 11.9496C6.83584 12.1496 5.40584 11.7396 4.36584 10.6996C3.41584 9.75957 2.97584 8.49957 3.04584 7.25957L6.13584 10.3496L10.3758 6.10957L7.28584 3.01957C8.52584 2.94957 9.77584 3.38957 10.7258 4.32957C11.8058 5.40957 12.2158 6.89957 11.9658 8.28957C11.8458 8.99957 11.5458 9.65957 11.0858 10.2496L20.5358 19.6996L19.6558 20.5896Z" />
          </svg>        
        </button>           
      </div>
    </div>        
  </div>
</template>

<script>
import format from '@/helpers/formatNumber'
import productServices from '@/services/product/productServices'
import collectionServices from '@/services/collection/collectionServices'
import unitServices from '@/services/unit/unitServices'
import rateServices from '@/services/rate/rateServices'
import SaveIcon from '../../icons/SaveIcon'
import BackIcon from '../../icons/BackIcon'
import Loading from '../../icons/Loading'
import imageBox from '../../../assets/images/file-box.png'
import UnitModal from '../unit/Modal'
import CollectionModal from '../collection/Modal'
import RateModal from '../rate/Modal'

export default {
  name: 'CreateProduct',
  components: {
    SaveIcon,
    BackIcon,
    Loading,
    UnitModal,
    CollectionModal,
    RateModal,
  },
  data(){
    return {
      seasonCreation: '',
      collection: '',
      barcode: '',
      reference: '',
      color: '',
      size: '',
      description: '',
      weight: '',
      high: '',
      width: '',
      long: '',
      carats: '',
      annotation: '',
      unit: '',
      units: [],
      currency: '',
      change_rate: '',
      image: '',
      productImage: '',
      fileBox: imageBox,
      collections: [],
      currencies: [],
      error: [],
      prevRoute: null,
      showFunction: false,
      isLoading: false,
      toastedOptions: {
        position: "top-right", 
        duration : 5000,
        action: {
          text: 'x',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          }
        }  
      }      
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },  
  methods: {
    async create(){
      try {
        this.isLoading = true
        let payload = new FormData()
        payload.append('season_creation', this.seasonCreation)
        payload.append('collection', this.collection.id)
        payload.append('barcode', this.barcode)
        payload.append('reference', this.reference)
        payload.append('color', this.color)
        payload.append('size', this.size ?? '')
        payload.append('description', this.description)
        payload.append('weight', this.weight)
        payload.append('high', this.high)
        payload.append('width', this.width)
        payload.append('long', this.long)
        payload.append('carats', this.carats)
        payload.append('annotation', this.annotation ?? '')
        payload.append('unit', this.unit)
        payload.append('currency', this.currency)
        payload.append('change_rate', this.unformatNumber(this.change_rate))
        payload.append('image', this.productImage)

        const response = await productServices.create(payload)
        if (response.data.status === 'success') {
          /* SET LOADING STATE IS FALSE */
          this.isLoading = false
                    
          /* CLEAR INPUT FORM */
          this.clearForm()

          /* EMPTY ERRORS VARIABLE */
          this.error = []
          
          /* SUCCESS MESSAGES */
          this.$toasted.success(response.data.message, this.toastedOptions)

          /* SET NEW ID & REDIRECT TO EDIT PAGE WITH CREATED ID */
          this.$store.dispatch('setNewProductID', response.data.data.id)
          this.$router.push({ name: 'productEdit', params: { id: response.data.data.id} })
        } else {
          /* SET LOADING STATE IS FALSE */
          this.isLoading = false

          /* EMPTY ERRORS VARIABLE */
          this.error = []

          /* STORE RESPONSE MESSAGE TO A VARIABLE */
          let responseReturn = response.data.message

          /* IF RESPONSE HAS OBJECT, STORE RESPONSE TO ERRORS VARIABLE */
          if (responseReturn.season_creation || responseReturn.collection || responseReturn.barcode || responseReturn.reference 
              || responseReturn.color || responseReturn.size || responseReturn.description || responseReturn.weight
              || responseReturn.high || responseReturn.width || responseReturn.long || responseReturn.carats || responseReturn.annotation 
              || responseReturn.unit || responseReturn.currency || responseReturn.change_rate || responseReturn.image) {
              this.error = response.data.message

          /* ELSE, THROW ERROR MESSAGES */
          } else {
            this.$toasted.error(response.data.message, this.toastedOptions)
          }          
        }
      } catch (error) {
        /* SET LOADING STATE IS FALSE */
        this.isLoading = false

        /* THROW ERROR MESSAGES */
        this.$toasted.error(error, this.toastedOptions)        
      }
    },
    async fetchCollectionData() {
      try {
        const response = await collectionServices.fetchDataOptions(null)
        if (response.data.status === 'success') {
          const records = response.data.data
          this.collections = []
          records.forEach(element => {
            this.collections.push({
              'id': element.id,
              'name': element.collection_name
            })
          });          
        } else {
          /* THROW ERROR MESSAGES */
          this.$toasted.error(response.data.message, this.toastedOptions)          
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchUnitData() {
      try {
        const response = await unitServices.fetchDataOptions(null)
        if (response.data.status === 'success') {
          const records = response.data.data
          this.units = []
          records.forEach(element => {
            this.units.push(element.unit)
          });
        } else {
          /* THROW ERROR MESSAGES */
          this.$toasted.error(response.data.message, this.toastedOptions)          
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchCurrencyData() {
      try {
        const response = await rateServices.fetchDataOptions(null)
        if (response.data.status === 'success') {
          const records = response.data.data
          this.currencies = []
          records.forEach(element => {
            this.currencies.push(element.currency)
          });
        } else {
          /* THROW ERROR MESSAGES */
          this.$toasted.error(response.data.message, this.toastedOptions)          
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchRateData(){
      try {
        const name = 'IDR'
        const response = await rateServices.fetchByCurrency(name)
        if (response.data.status === 'success') {
          this.record = response.data.data

          this.change_rate = this.formatNumber(this.record.rate)
        } else {
          this.change_rate = 0       
        }
      } catch (error) {
        console.log(error)
      }
    },    
    clearForm(){
      this.seasonCreation = ''
      this.collection = ''
      this.barcode = ''
      this.reference = ''
      this.color = ''
      this.size = ''
      this.description = ''
      this.weight = ''
      this.high = ''
      this.width = ''
      this.long = ''
      this.carats = ''
      this.annotation = ''
      this.unit = ''
      this.currency = ''
      this.change_rate = ''
      this.image = ''
      this.productImage = ''
    },
    formatNumber(num) {
      let result = format.formatNumber(num)
      return result
    },
    unformatNumber(num) {
      let result = format.unformatNumber(num)
      return result
    },
    toFixed(num, digit) {
      let result = format.toFixed(num, digit)
      return result
    },   
    handleInputRate(event) {
      this.change_rate = this.formatNumber(event.target.value)
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }

      this.createImage(files[0])
    },
    createImage(file) {
      let reader = new FileReader()
      let vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
      this.productImage = this.$refs.image.files[0]
    },
    removeImage() {
      this.image = ''
    },
    toggleFunction() {
      this.showFunction = !this.showFunction
    },
    goBack() {
      window.history.length > 1 ? this.$router.back() : this.$router.push('/products')
    }    
  },
  created(){
    this.fetchCollectionData()
    this.fetchUnitData()
    this.fetchCurrencyData()
    this.fetchRateData()
  },
  watch: {
    prevRoute: function() {
      this.$store.dispatch('setIndexProductRoute', this.prevRoute)
    }
  },
  mounted() {
    const thisInstance = this  
    this.$root.$on('fetchCollection', function(){
      thisInstance.fetchCollectionData()
    }),
    this.$root.$on('fetchUnit', function(){
      thisInstance.fetchUnitData()
    }),    
    this.$root.$on('fetchRate', function(){
      thisInstance.fetchRateData()
    })            
  }
}
</script>